<template>
    <div>
        <h1>Cheque not yet deposited</h1>
    </div>
</template>
    
<script setup>

</script>